import React, { useContext } from "react";
import { BankOwnerContext } from "./BankOwnerContext";
import "./bankOwnerBanks.css"
import Pagination from "../../Pagination";
import Spinner from "../../Spinner";
export default function BankOwnerBanks() {
//     const styles = `
//     .bank-grid {
//       display: grid;
//       grid-template-columns: repeat(4, 1fr);
//       gap: 20px;
//       width:100%;      
//     }
  
//     .bank-card {
//       position: relative;
//       border: 1px solid #ccc;
//       border-radius: 8px;
//       overflow: hidden;
//       height: 400px; 
//     }
  
//     .bank-container {
//       position: relative;
//       overflow: hidden;
//       height: 100%; 
//     }
  
//     .bank-image {
//       width: 100%;
//       height: 400px;
//       object-fit: cover;
//     }
  
//     .edit-button, .delete-button {
//       position: absolute;
//       padding: 5px 10px;
//       border: none;
//       border-radius: 5px;
//       cursor: pointer;
//       z-index: 1;
//     }
  
//     .edit-button {
//       top: 10px;
//       right: 10px;
//       background-color: blue;
//       color: white;
//     }
  
//     .delete-button {
//       top: 10px;
//       left: 10px;
//       background-color: red;
//       color: white;
//     }
  
//     .data-overlay {
//       position: absolute;
//       bottom: 10px;
//       left: 50%;
//       transform: translateX(-50%);
//       color: white;
//       text-align: center;
//       text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
//       background-color: rgba(0, 0, 0, 0.5);
//       padding: 10px;
//       width: calc(100% - 20px); 
//       box-sizing: border-box; 
//     }
  
//     @media (max-width: 1200px) {
//       .bank-grid {
//         grid-template-columns: repeat(4, 1fr);
//         .bank-card{
//         width:300 px;
//         }
//       }
//     }
//   @media (width:400px){
//  .bank-grid{
//   width:300px;
//   margin:50px 50px;
//  }
// }
//     @media (max-width: 900px) {
//       .bank-grid {
//         grid-template-columns: repeat(3, 1fr);
//       }
//     }
  
//     @media (max-width: 600px) {
//       .bank-grid {
//         grid-template-columns: repeat(2, 1fr);
//       }
//     }
//     @media (width:400px){
//     .bank-grid{
//     width:300px;
//     margin:50px 50 px;
//     }
//     }
//     @media (max-width: 400px) {
//       .bank-grid {
//         grid-template-columns: repeat(1, 1fr);
        
//       }
//     }

    
//   `;

//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = styles;
//     document.head.appendChild(styleSheet);
    const {        
         availableBanks,
        formik,
        setBankToDel,
        allBankOwnersBanks,
        postsPerPage,
        currentPage,
        paginate,
        newBanksData,
        selectedBank,
        setSelectedBank} = useContext(BankOwnerContext);       
    // Create a value to determine whether a pagination should occur
    const shouldPaginate = allBankOwnersBanks.length > 4
    const displayedBanks = shouldPaginate ? newBanksData : allBankOwnersBanks
//    console.log(displayedBanks)
    return (
        <div className="  max-w-full min-w-fit mb-20">  
            {displayedBanks.length > 0 ? (
              <div>  
                    <div className=" bank-grid  mt-2">
                    {displayedBanks.map((bank)=>(
                        <div className="bank-card" key={bank.id}>
                            <div className="bank-container">
                                    <div className="top-10 right-5">                                                       
                                                        <form onSubmit={formik.handleSubmit}>
                                                            <button
                                                                className="bg-red-500 text-white rounded-full"
                                                                onClick={() => {
                                                                    setBankToDel(true);
                                                                    formik.setFieldValue("bank_name", bank.name);
                                                                }}
                                                                type="submit"
                                                            >
                                                                DELETE
                                                            </button>
                                                        </form>
                                                    </div>
                                                    <img
                                                        src={bank.image_url}
                                                        alt={bank.name}
                                                        className="bank-image object-cover"

                                                    />
                                                    <div className="data-overlay max-w-full min-w-fit">
                                                        <p className="text-white italic">{bank.name}</p>
                                                        <p className="text-white italic">{bank.email}</p>
                                                        <h4 className="text-white italic">{bank.hq_location}</h4>
                                                        <p className="text-white italic">{bank.paybill}</p>
                                                    </div>
                                    </div>

                        </div>
                    ))}
                    </div>
              
                    
                </div>
            ) : (
                <p>Sorry you do not have any banks, want to add</p>
            )}
           {shouldPaginate ?<Pagination postsPerPage={postsPerPage} totalPosts={allBankOwnersBanks.length} currentPage={currentPage} paginate={paginate}/>:null}

            {availableBanks.length > 0? (
                <div className="mt-6 max-w-full min-w-fit mb-12">
                    <h4 className="text-lg font-semibold mb-4">Request to Add a Bank</h4>
                    <form onSubmit={formik.handleSubmit}>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="bank_name">
                            Select Bank
                        </label>
                        <select
                            value={selectedBank}
                            onChange={(e) => {
                                setSelectedBank(e.target.value);
                                formik.setFieldValue("bank_name", e.target.value);
                            }}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name="bank_name"
                            id="bank_name"
                            required
                        >
                            <option value="">Select a bank</option>
                            {availableBanks.map((bank, index) => (
                                <option key={index} value={bank.name}>
                                    {bank.name}
                                </option>
                            ))}
                        </select>
                        {formik.errors.bank_name && formik.touched.bank_name && (
                            <div className="text-red-500 text-sm">{formik.errors.bank_name}</div>
                        )}
                        <button
                            type="submit"
                            onClick={() => setBankToDel(false)}
                            disabled={formik.isSubmitting || !formik.isValid}
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mt-4 disabled:opacity-50"
                        >
                            Send Request
                        </button>
                    </form>
                </div> 
             ):null}


        </div>

    );
}

